import ApiService from "../../../core/services/ApiService";

export interface ClientDto {
  id: string;
  name: string;
  nuemonic: string;
  isActive: boolean;
  dateCreated: string;
}

export interface ClientCreateDto {
  name: string;
  nuemonic: string;
}

class ClientService extends ApiService {
  async getAllClients(): Promise<ClientDto[]> {
    return this.makeRequest<ClientDto[]>("/api/client", {
      extractData: true,
    });
  }

  async getClientById(id: string): Promise<ClientDto> {
    return this.makeRequest<ClientDto>(`/api/client/${id}`, {
      extractData: true,
    });
  }

  async createClient(data: ClientCreateDto): Promise<string> {
    return this.makeRequest<string>("/api/client/create", {
      method: "POST",
      data: data as any,
      extractData: true,
    });
  }
}

export default ClientService;
